export default __webpack_public_path__ + "static/media/2023- GHSI Notice of Annual Stockholders Meeting.3ac7c325.pdf";